import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import appleWallet from "../../../../assets/images/Applewallet.svg";
import claimFileIcon from "../../../../assets/images/claim-file.svg";
import goldIcon from "../../../../assets/images/Gold.svg";
import phoneOverviewIcon from "../../../../assets/images/phone-overview.svg";
import platiniumIcon from "../../../../assets/images/Platinium.svg";
import silverIcon from "../../../../assets/images/Silver.svg";
import whatsappOverviewIcon from "../../../../assets/images/whatsapp-overview.svg";
import PerformanceCard from "../../../../components/common/card/performanceCard";
import DownloadBtn from "../../../../components/common/downloadBtn/downloadBtn";
import Loader from "../../../../components/common/Loader/Loader";
import SkeletonLoader from "../../../../components/common/Loader/SkeletonLoader";
import Shimmer from "../../../../components/common/Loader/Shimmer";
import PolicyCard from "../../../../components/policyCard/policyCard";
import useAppleWalletApi from "../../../../hooks/useAppleWallet";
import useLanguageTranslate from "../../../../hooks/useLanguageTranslate";
import useScreenResolution from "../../../../hooks/useScreenResolution";
import { selectUserPoliciesData } from "../../../../redux/features/myPolicySlice";
import { decodeQueryString } from "../../../../utils";
import { generatePolicyCardInfo } from "../../../../utils/policyCardUtils";
import { getProductCovers } from "../../../../api/contentServices";
import { policyOverview } from "../motorPolicyDataFile";

const PolicyOverviewTab = ({
  handleDownloadMenuClicked,
  showDownloadPopup,
  doc,
  status,
  policyDetails,
}) => {
  const [docLabel, setDoc] = useState([]);
  const isNonMotorPolicy = (productCode) =>
    productCode && productCode !== "0204";
  const [benefitsExpanded, setBenefitsExpanded] = useState(
    isNonMotorPolicy(policyDetails?.PolicyHeader?.ProductCode)
  );
  const [benefitsDefaultAppliedFor, setBenefitsDefaultAppliedFor] =
    useState(null);
  const [apiBenefits, setApiBenefits] = useState([]);
  const [benefitsLoading, setBenefitsLoading] = useState(false);
  const { id } = useParams();
  const params = decodeQueryString();
  const screenResolution = useScreenResolution();
  const userPolicies = useSelector(selectUserPoliciesData); //filter required policy

  const filteredPolicy = userPolicies?.filter(
    (policy) => policy.PolicyNumber == params.policy
  );
  console.log(filteredPolicy);
  const { AppleWalletApiTrigger, isLoading, isAppleDevice } = useAppleWalletApi(
    policyDetails?.PolicyHeader?.PolicyNumber
  );

  useEffect(() => {
    // Ensure doc is defined and is an array before setting
    if (Array.isArray(doc)) {
      setDoc(doc);
    } else {
      setDoc([]); // Set to empty array if doc is not an array
    }
  }, [doc]);

  // Apply the default expanded state for the Included Benefits section once
  // policyDetails has loaded. Non-motor policies default to expanded; motor
  // stays collapsed. Keyed by policy number so user toggles are preserved
  // and the default is re-applied only when switching policies.
  useEffect(() => {
    const productCode = policyDetails?.PolicyHeader?.ProductCode;
    const policyNumber = policyDetails?.PolicyHeader?.PolicyNumber;
    if (!productCode || !policyNumber) return;
    if (benefitsDefaultAppliedFor === policyNumber) return;
    setBenefitsExpanded(isNonMotorPolicy(productCode));
    setBenefitsDefaultAppliedFor(policyNumber);
  }, [
    policyDetails?.PolicyHeader?.ProductCode,
    policyDetails?.PolicyHeader?.PolicyNumber,
    benefitsDefaultAppliedFor,
  ]);

  useEffect(() => {
    const productCode = policyDetails?.PolicyHeader?.ProductCode;
    if (!productCode) return;

    // Use a `cancelled` flag (no AbortController) so React 18 StrictMode's
    // double-invocation of effects in dev — and any re-render — does not
    // produce a cancelled request in the network panel. The late response
    // is simply ignored if the effect was cleaned up.
    let cancelled = false;
    setApiBenefits([]);
    setBenefitsLoading(true);
    // Auto-expand on mobile so the skeleton is visible while loading and
    // the loaded benefits remain visible after — avoids flash-open-then-close.
    setBenefitsExpanded(true);
    getProductCovers(productCode)
      .then((result) => {
        if (cancelled) return;
        if (result.success && result.data.length > 0) {
          setApiBenefits(result.data);
        }
      })
      .finally(() => {
        if (!cancelled) setBenefitsLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [policyDetails?.PolicyHeader?.ProductCode]);

  const translate = useLanguageTranslate();

  // Safely iterate over docLabel only if it's an array
  if (Array.isArray(docLabel)) {
    for (const i of docLabel) {
      console.log(i.ID); // Process each item
    }
  } else {
    console.error("docLabel is not an array");
  }

  const downloadCard = {
    label_en: "Your insurance policy documents",
    label_ar: "وثائق سياسة التأمين الخاصة بك:",
    download_btn: true,
    filesData: [],
  };

  for (var document of docLabel) {
    downloadCard.filesData.push({
      fileName: document.ID,
      fileName_ar: document.ID,
      filesData: {
        url: document.File,
        size: "165.7 KB",
      },
    });
  }

  return (
    <>
      {screenResolution.mobile && (
        <div className="max767:p-5 max767:pb-[0px]">
          {console.log("policyDetails WM", filteredPolicy)}
          {/* Non-Motor Policy Cards - Show for all non-motor insurance types */}
          {(() => {
            const productCode = policyDetails?.PolicyHeader?.ProductCode;
            // Check by product code
            if (
              ["0204", "0710", "0206", "0205", "0208", "0222"].includes(
                productCode
              )
            ) {
              return true;
            }
            // Fallback: Check for personal cyber or smart device by name (in case different product code)
            const productName =
              policyDetails?.PolicyHeader?.ProductName?.toLowerCase() || "";
            const planName =
              policyDetails?.PolicyHeader?.PlanName?.toLowerCase() || "";
            return (
              productName.includes("personal cyber") ||
              productName.includes("cyber") ||
              planName.includes("personal cyber") ||
              planName.includes("cyber") ||
              productName.includes("smart device") ||
              productName.includes("device") ||
              planName.includes("smart device") ||
              planName.includes("device")
            );
          })() ? (
            <PolicyCard
              policy_name={(() => {
                const productCode = policyDetails?.PolicyHeader?.ProductCode;
                if (productCode === "0204") return "Travel Insurance";
                if (productCode === "0710") return "Home Insurance";
                if (productCode === "0206") return "Personal Cyber Insurance";
                if (productCode === "0205") return "Smart Device Insurance";
                if (productCode === "0208")
                  return "Personal Accident Insurance";
                if (productCode === "0222") return "Domestic Helper Insurance";

                // Fallback: Check by name for personal cyber or smart device
                const productName =
                  policyDetails?.PolicyHeader?.ProductName?.toLowerCase() || "";
                const planName =
                  policyDetails?.PolicyHeader?.PlanName?.toLowerCase() || "";
                if (
                  productName.includes("personal cyber") ||
                  productName.includes("cyber") ||
                  planName.includes("personal cyber") ||
                  planName.includes("cyber")
                ) {
                  return "Personal Cyber Insurance";
                }
                if (
                  productName.includes("smart device") ||
                  productName.includes("device") ||
                  planName.includes("smart device") ||
                  planName.includes("device")
                ) {
                  return "Smart Device Insurance";
                }

                return "Insurance Policy";
              })()}
              policy_label={(() => {
                const productCode = policyDetails?.PolicyHeader?.ProductCode;
                if (productCode === "0204") return "Travel Policy";
                if (productCode === "0710") return "Home Policy";
                if (productCode === "0206") return "Personal Cyber Policy";
                if (productCode === "0205") return "Smart Device Policy";
                if (productCode === "0208") return "Personal Accident Policy";
                if (productCode === "0222") return "Domestic Helper Policy";

                // Fallback: Check by name for personal cyber or smart device
                const productName =
                  policyDetails?.PolicyHeader?.ProductName?.toLowerCase() || "";
                const planName =
                  policyDetails?.PolicyHeader?.PlanName?.toLowerCase() || "";
                if (
                  productName.includes("personal cyber") ||
                  productName.includes("cyber") ||
                  planName.includes("personal cyber") ||
                  planName.includes("cyber")
                ) {
                  return "Personal Cyber Policy";
                }
                if (
                  productName.includes("smart device") ||
                  productName.includes("device") ||
                  planName.includes("smart device") ||
                  planName.includes("device")
                ) {
                  return "Smart Device Policy";
                }

                return "Policy";
              })()}
              policy_number={policyDetails?.PolicyHeader?.PolicyNumber}
              from_date={
                policyDetails?.PolicyHeader?.FromDateStr?.split(" ")[0]
              }
              to_date={policyDetails?.PolicyHeader?.ToDateStr?.split(" ")[0]}
              policy_bg_image=""
              expire_days=""
              is_text_dark={false}
              mapping_key={`${policyDetails?.PolicyHeader?.ProductCode}_policy`}
              data={generatePolicyCardInfo(
                policyDetails?.PolicyHeader,
                "online.solidarity"
              )}
              disableCardClick
            />
          ) : (
            // Motor and other policy types - use filteredPolicy
            filteredPolicy?.map((each, index) => (
              <PolicyCard
                key={index}
                policy_name={each.policy_name}
                policy_label={each.policy_label}
                policy_number={each.policy_number}
                from_date={each.from_date}
                to_date={each.to_date}
                policy_bg_image={each.policy_bg_image}
                expire_days={each.expire_days}
                is_text_dark={each.is_text_dark}
                mapping_key={each.id}
                data={each}
              />
            ))
          )}
        </div>
      )}
      {isAppleDevice && (
        <div className="px-5 ipad:px-0 ipad:mt-4">
          <button
            onClick={AppleWalletApiTrigger}
            disabled={isLoading}
            className="AppleWallet flex justify-center items-center gap-2 self-stretch bg-black px-2 py-4 rounded-[10px] text-white text-base not-italic font-[510] leading-[120%] w-full max767:mt-2 hover:bg-black disabled:opacity-70 disabled:cursor-not-allowed"
          >
            {isLoading ? (
              <>
                <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                </svg>
                <span className="text-white text-base font-[510]">Adding to Wallet...</span>
              </>
            ) : (
              <>
                <img src={appleWallet} alt="Apple Wallet Icon" />
                Add to Apple Wallet
              </>
            )}
          </button>
        </div>
      )}

      <div className="policy-over max767:px-5 max767:py-8 ">
        {/* Travel Insurance Layout */}
        {(() => {
          // Check for travel insurance (product code 0204)
          if (policyDetails?.PolicyHeader?.ProductCode == "0204") {
            return true;
          }

          // Check for smart device insurance (product code 0213)
          if (policyDetails?.PolicyHeader?.ProductCode == "0213") {
            return true;
          }

          // Check for home insurance (product code 0710)
          if (policyDetails?.PolicyHeader?.ProductCode == "0710") {
            return true;
          }

          // Check for personal accident insurance (product code 0202)
          if (policyDetails?.PolicyHeader?.ProductCode == "0202") {
            return true;
          }

          // Check for domestic helper insurance (product code 0222)
          if (policyDetails?.PolicyHeader?.ProductCode == "0222") {
            return true;
          }

          // Check for personal cyber policies by name (fallback for different product codes)
          const productName =
            policyDetails?.PolicyHeader?.ProductName?.toLowerCase() || "";
          const planName =
            policyDetails?.PolicyHeader?.PlanName?.toLowerCase() || "";
          const isPersonalCyber =
            productName.includes("personal cyber") ||
            productName.includes("cyber") ||
            planName.includes("personal cyber") ||
            planName.includes("cyber");

          return isPersonalCyber;
        })() ? (
          <>
            {/* Plan Details and Actions Grid */}
            <div className="grid grid-cols-1 lg:grid-cols-5 gap-6 mb-6 max767:gap-4">
              {/* Left side - Plan Details (3 columns) */}
              <div className="col-span-1 lg:col-span-3">
                <div className="bg-white border border-[#DDE2E4] rounded-2xl p-6 h-full">
                  {/* Plan Header with Real Plan Icon - ONLY for travel insurance */}
                  <div className="flex items-center gap-4 mb-6">
                    {/* Only show plan icon for travel insurance (product code 0204) */}
                    {policyDetails?.PolicyHeader?.ProductCode === "0204" &&
                      (() => {
                        // Map plan names/codes to icons
                        const planName = policyDetails?.PolicyHeader?.PlanName;
                        const planCode = policyDetails?.PolicyHeader?.PlanCode;

                        // Convert plan codes to names for mapping
                        let mappedPlanName = planName;
                        if (planCode === "SILVER") mappedPlanName = "Silver";
                        else if (planCode === "GO") mappedPlanName = "Gold";
                        else if (planCode === "PL") mappedPlanName = "Platinum";

                        const planLower = mappedPlanName?.toLowerCase();
                        let planIcon = silverIcon; // default

                        if (planLower === "gold") planIcon = goldIcon;
                        else if (
                          planLower === "platinum" ||
                          planLower === "platinium"
                        )
                          planIcon = platiniumIcon;

                        return (
                          <img
                            src={planIcon}
                            alt={`${mappedPlanName || "Silver"} Plan Icon`}
                            className="w-12 h-12"
                          />
                        );
                      })()}
                    <h2 className="text-[#48535B] text-[32px] max767:text-xl font-semibold">
                      {(() => {
                        // Check for smart device insurance first
                        if (
                          policyDetails?.PolicyHeader?.ProductCode == "0213"
                        ) {
                          return translate("Smart Device Insurance Policy", "سياسة التأمين على الأجهزة الذكية");
                        }

                        // Check for home insurance
                        if (
                          policyDetails?.PolicyHeader?.ProductCode == "0710"
                        ) {
                          return translate("Home Insurance Policy", "سياسة التأمين المنزلي");
                        }

                        // Check for personal accident insurance
                        if (
                          policyDetails?.PolicyHeader?.ProductCode == "0202"
                        ) {
                          return translate("Personal Accident Insurance Policy", "سياسة التأمين على الحوادث الشخصية");
                        }

                        // Check for domestic helper insurance
                        if (
                          policyDetails?.PolicyHeader?.ProductCode == "0222"
                        ) {
                          return translate("Domestic Helper Insurance Policy", "سياسة تأمين المساعد المنزلي");
                        }

                        // Check for personal cyber policies
                        const productName =
                          policyDetails?.PolicyHeader?.ProductName?.toLowerCase() ||
                          "";
                        const planNameLower =
                          policyDetails?.PolicyHeader?.PlanName?.toLowerCase() ||
                          "";
                        const isPersonalCyber =
                          productName.includes("personal cyber") ||
                          productName.includes("cyber") ||
                          planNameLower.includes("personal cyber") ||
                          planNameLower.includes("cyber");

                        if (isPersonalCyber) {
                          return translate("Personal Cyber Insurance", "التأمين السيبراني الشخصي");
                        }

                        // Travel insurance titles
                        const planName = policyDetails?.PolicyHeader?.PlanName;
                        const planCode = policyDetails?.PolicyHeader?.PlanCode;

                        // Convert plan codes to display names with Arabic support
                        if (planCode === "SILVER") return translate("Silver Plan", "خطة الفضة");
                        if (planCode === "GO") return translate("Gold Plan", "الخطة الذهبية");
                        if (planCode === "PL") return translate("Platinum Plan", "الخطة البلاتينية");
                        if (planCode === "WLEXB") return translate("Worldwide excluding USA & Canada", "جميع أنحاء العالم باستثناء الولايات المتحدة وكندا");
                        if (planCode === "WLB") return translate("Worldwide Plan", "خطة جميع أنحاء العالم");
                        if (planCode === "SCHENGENB") return translate("Schengen Plan", "خطة شنغن");
                        if (planName) {
                          // Map planName to English/Arabic if needed
                          const lowerPlanName = planName.toLowerCase();
                          if (lowerPlanName.includes("silver")) return translate("Silver Plan", "خطة الفضة");
                          if (lowerPlanName.includes("gold")) return translate("Gold Plan", "الخطة الذهبية");
                          if (lowerPlanName.includes("platinum") || lowerPlanName.includes("platinium")) return translate("Platinum Plan", "الخطة البلاتينية");
                          if (lowerPlanName.includes("wlexb") || lowerPlanName.includes("worldwide_ex") || lowerPlanName.includes("worldwide excl")) {
                            return translate("Worldwide excluding USA & Canada", "جميع أنحاء العالم باستثناء الولايات المتحدة وكندا");
                          }
                          if (lowerPlanName.includes("schengen")) {
                            return translate("Schengen Plan", "خطة شنغن");
                          }
                          if (lowerPlanName.includes("wlb") || lowerPlanName.includes("worldwide")) {
                            return translate("Worldwide Plan", "خطة جميع أنحاء العالم");
                          }
                          return `${planName} Plan`;
                        }
                        return translate("Silver Plan", "خطة الفضة");
                      })()}
                    </h2>
                  </div>

                  {/* Dynamic Benefits based on Plan with proper check marks */}
                  <div className="mb-4 max767:mb-0">
                    {/* Mobile: Collapsible Benefits Header */}
                    <div className="max767:block hidden">
                      <button
                        onClick={() => setBenefitsExpanded(!benefitsExpanded)}
                        className="flex items-center gap-2 w-full text-left"
                      >
                        <svg
                          className={`w-5 h-5 text-[#1A2024] transform transition-transform duration-300 ease-in-out ${
                            benefitsExpanded ? "rotate-90" : "rotate-0"
                          }`}
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M9 5l7 7-7 7"
                          />
                        </svg>
                        <h3 className="text-[#1A2024] text-base font-medium">
                          {benefitsExpanded
                            ? translate("Included benefits", "المزايا المشمولة")
                            : translate("Included benefits", "المزايا المشمولة")}
                        </h3>
                      </button>
                    </div>

                    {/* Desktop: Static Benefits Header */}
                    <h3 className="text-[#1A2024] text-lg font-semibold max767:hidden">
                      {translate("Included Benefits", "المزايا المشمولة")}
                    </h3>
                  </div>

                  {/* Benefits List */}
                    <div
                      className={`space-y-3 transition-all duration-300 ease-in-out overflow-hidden ${
                      screenResolution.mobile
                        ? benefitsExpanded
                          ? "max-h-[2000px] opacity-100 mt-3"
                          : "max-h-0 opacity-0 mt-0"
                        : "max-h-none opacity-100"
                    }`}
                    >
                      {(() => {
                        if (benefitsLoading) {
                          return (
                            <div
                              className="space-y-3"
                              role="status"
                              aria-label={translate("Loading benefits...", "جاري تحميل المزايا...")}
                            >
                              {[85, 70, 90, 60, 78].map((w, i) => (
                                <div key={i} className="flex items-start gap-3">
                                  <Shimmer className="flex-shrink-0 w-4 h-4 mt-1 rounded-full" />
                                  <Shimmer className="h-3.5" style={{ width: `${w}%` }} />
                                </div>
                              ))}
                            </div>
                          );
                        }
                        return apiBenefits.map((benefit, index) => (
                        <div key={index} className="flex items-start gap-3">
                          {/* Design-compliant check mark */}
                          <div className="flex-shrink-0 w-4 h-4 mt-1">
                            <svg
                              viewBox="0 0 16 16"
                              fill="none"
                              className="w-4 h-4"
                            >
                              <path
                                d="M13.5 4.5L6 12L2.5 8.5"
                                stroke="#22c55e"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </div>
                          <span className="text-black text-sm leading-relaxed">
                            {typeof benefit === 'string' ? benefit : translate(benefit.en, benefit.ar)}
                          </span>
                        </div>
                      ));
                    })()}
                  </div>
                </div>
              </div>

              {/* Right side - Actions and Assistance (2 columns) */}
              <div className="col-span-1 lg:col-span-2 space-y-6">
                {/* File a Claim - Updated styling with full area clickable */}
                <div
                  onClick={() => (window.location.href = "/file-a-claim")}
                  className="bg-[#F6F8F9] border border-[#DDE2E4] rounded-2xl p-6 cursor-pointer hover:bg-gray-100 transition-colors"
                >
                  <div className="flex items-center gap-3 text-[#48535B] text-lg font-normal">
                    <img
                      src={claimFileIcon}
                      alt="File a Claim"
                      className="w-9 h-9"
                    />
                    {translate("File a Claim", "تقديم مطالبة")}
                  </div>
                </div>

                {/* Assistance Section - Shows for all products with appropriate title */}
                <div className="bg-[#F6F8F9] rounded-2xl p-6">
                    <h4 className="text-[#48535B] text-lg font-medium mb-4">
                      {(() => {
                        // Check for smart device insurance first
                        if (policyDetails?.PolicyHeader?.ProductCode == "0213") {
                          return translate("Smart Device Assistance", "مساعدة الأجهزة الذكية");
                        }

                        // Check for home insurance
                        if (policyDetails?.PolicyHeader?.ProductCode == "0710") {
                          return translate("Home Insurance Assistance", "مساعدة التأمين المنزلي");
                        }

                        // Check for personal accident insurance
                        if (policyDetails?.PolicyHeader?.ProductCode == "0202") {
                          return translate("Personal Accident Assistance", "مساعدة الحوادث الشخصية");
                        }

                        // Check for domestic helper insurance
                        if (policyDetails?.PolicyHeader?.ProductCode == "0222") {
                          return translate("Domestic Helper Assistance", "مساعدة العمالة المنزلية");
                        }

                        // Check for personal cyber insurance
                        if (policyDetails?.PolicyHeader?.ProductCode == "0640") {
                          return translate("Personal Cyber Assistance", "مساعدة السيبراني الشخصي");
                        }

                        return translate("Travel Assistance", "مساعدة السفر");
                      })()}
                  </h4>
                  <div className="flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-6">
                    <button
                      onClick={() => {
                        // Check for smart device insurance first
                        if (
                          policyDetails?.PolicyHeader?.ProductCode == "0213"
                        ) {
                          window.location.href = "tel:+97317223351";
                          return;
                        }

                        // Check for home insurance
                        if (
                          policyDetails?.PolicyHeader?.ProductCode == "0710"
                        ) {
                          window.location.href = "tel:+97317223351";
                          return;
                        }

                        // Check for personal accident insurance
                        if (
                          policyDetails?.PolicyHeader?.ProductCode == "0202"
                        ) {
                          window.location.href = "tel:+97317223351";
                          return;
                        }

                        // Check for domestic helper insurance
                        if (
                          policyDetails?.PolicyHeader?.ProductCode == "0222"
                        ) {
                          window.location.href = "tel:+97317223351";
                          return;
                        }

                        // Check for personal cyber insurance
                        if (
                          policyDetails?.PolicyHeader?.ProductCode == "0640"
                        ) {
                          window.location.href = "tel:+97317223351";
                          return;
                        }

                        // Check for personal cyber policies by name (fallback)
                        const productName =
                          policyDetails?.PolicyHeader?.ProductName?.toLowerCase() ||
                          "";
                        const planNameLower =
                          policyDetails?.PolicyHeader?.PlanName?.toLowerCase() ||
                          "";
                        const isPersonalCyber =
                          productName.includes("personal cyber") ||
                          productName.includes("cyber") ||
                          planNameLower.includes("personal cyber") ||
                          planNameLower.includes("cyber");

                        const phoneNumber = isPersonalCyber
                          ? "tel:+97317223351"
                          : "tel:+96265008119";
                        window.location.href = phoneNumber;
                      }}
                      className="flex items-center gap-2 text-[#1A2024] font-semibold text-sm"
                    >
                      <img
                        src={phoneOverviewIcon}
                        alt="Phone"
                        className="w-5 h-5"
                      />
                      {(() => {
                        // Check for smart device insurance first
                        if (
                          policyDetails?.PolicyHeader?.ProductCode == "0213"
                        ) {
                          return translate("Call +973 17223351", "اتصل على 17223351 973+");
                        }

                        // Check for home insurance
                        if (
                          policyDetails?.PolicyHeader?.ProductCode == "0710"
                        ) {
                          return translate("Call +973 17223351", "اتصل على 17223351 973+");
                        }

                        // Check for personal accident insurance
                        if (
                          policyDetails?.PolicyHeader?.ProductCode == "0202"
                        ) {
                          return translate("Call +973 17223351", "اتصل على 17223351 973+");
                        }

                        // Check for domestic helper insurance
                        if (
                          policyDetails?.PolicyHeader?.ProductCode == "0222"
                        ) {
                          return translate("Call +973 17223351", "اتصل على 17223351 973+");
                        }

                        // Check for personal cyber insurance
                        if (
                          policyDetails?.PolicyHeader?.ProductCode == "0640"
                        ) {
                          return translate("Call +973 17223351", "اتصل على 17223351 973+");
                        }

                        // Check for personal cyber policies by name (fallback)
                        const productName =
                          policyDetails?.PolicyHeader?.ProductName?.toLowerCase() ||
                          "";
                        const planNameLower =
                          policyDetails?.PolicyHeader?.PlanName?.toLowerCase() ||
                          "";
                        const isPersonalCyber =
                          productName.includes("personal cyber") ||
                          productName.includes("cyber") ||
                          planNameLower.includes("personal cyber") ||
                          planNameLower.includes("cyber");

                        return isPersonalCyber
                          ? translate("Call +973 17223351", "اتصل على 17223351 973+")
                          : translate("Call +962 6500 8119", "اتصل على 6500 8119 962+");
                      })()}
                    </button>
                    <button
                      onClick={() => {
                        // Check for smart device insurance first
                        if (
                          policyDetails?.PolicyHeader?.ProductCode == "0213"
                        ) {
                          window.open("https://wa.me/97317223351", "_blank");
                          return;
                        }

                        // Check for home insurance
                        if (
                          policyDetails?.PolicyHeader?.ProductCode == "0710"
                        ) {
                          window.open("https://wa.me/97317223351", "_blank");
                          return;
                        }

                        // Check for personal accident insurance
                        if (
                          policyDetails?.PolicyHeader?.ProductCode == "0202"
                        ) {
                          window.open("https://wa.me/97317223351", "_blank");
                          return;
                        }

                        // Check for domestic helper insurance
                        if (
                          policyDetails?.PolicyHeader?.ProductCode == "0222"
                        ) {
                          window.open("https://wa.me/97317223351", "_blank");
                          return;
                        }

                        // Check for personal cyber insurance
                        if (
                          policyDetails?.PolicyHeader?.ProductCode == "0640"
                        ) {
                          window.open("https://wa.me/97317223351", "_blank");
                          return;
                        }

                        // Check for personal cyber policies by name (fallback)
                        const productName =
                          policyDetails?.PolicyHeader?.ProductName?.toLowerCase() ||
                          "";
                        const planNameLower =
                          policyDetails?.PolicyHeader?.PlanName?.toLowerCase() ||
                          "";
                        const isPersonalCyber =
                          productName.includes("personal cyber") ||
                          productName.includes("cyber") ||
                          planNameLower.includes("personal cyber") ||
                          planNameLower.includes("cyber");

                        const whatsappUrl = isPersonalCyber
                          ? "https://wa.me/97317223351"
                          : "https://wa.me/96265008119";
                        window.open(whatsappUrl, "_blank");
                      }}
                      className="flex items-center gap-2 text-[#1A2024] font-semibold text-sm"
                    >
                      <img
                        src={whatsappOverviewIcon}
                        alt="WhatsApp"
                        className="w-5 h-5"
                      />
                      {translate("WhatsApp", "واتساب")}
                    </button>
                  </div>
                </div>

                {/* Documents Section - Desktop only */}
                <div className="justify-center items-start gap-2 self-stretch bg-[#F6F8F9] p-6 rounded-[10px] max767:hidden">
                  <div className="flex items-center justify-between mb-4">
                    <h3 className="text-[#1A2024] text-sm not-italic font-medium leading-[normal]">
                      {translate(
                        "Your insurance policy documents:",
                        "وثائق سياسة التأمين الخاصة بك:"
                      )}
                    </h3>
                    {/* Show "View All" button only if more than 2 documents */}
                    {docLabel && docLabel.length > 2 && (
                      <button
                        onClick={handleDownloadMenuClicked}
                        className="text-[#00719A] text-sm font-medium hover:underline"
                      >
                        {translate("View All", "عرض الكل")}
                      </button>
                    )}
                  </div>
                  {downloadCard?.download_btn && (
                    <div className="gap-2 download-wrapper flex flex-col w-full ipad:flex ipad:w-[95%]">
                      <DownloadBtn
                        doc={docLabel.slice(0, 2)} // Show only first 2 documents
                        filesData={downloadCard.filesData.slice(0, 2)} // Show only first 2 documents
                        className={"gap-2 shrink w-full mb-2"}
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>

          </>
        ) : (
          /* Motor Insurance Layout - Existing cards */
          <div className="flex flex-wrap gap-4 ipad:flex-nowrap ipad:gap-2 max767:col-span-2 policyoverview">
            {policyOverview.cards
              .filter((card) => {
                // Example logic: Exclude cards with empty `icon` only if it's required
                if (card.icon == "" && !card.call_option) return false;

                // Exclude specific card by value
                if (
                  card.value == "Home Assistance" &&
                  policyDetails?.PolicyHeader?.ProductCode == "0101" &&
                  policyDetails?.PolicyHeader?.Covers?.some(
                    (cover) => cover.coverCode == "CMOT28"
                  )
                ) {
                  card.call_option = card.call_option || {}; // Ensure `call_option` exists
                  card.call_option.lable_en = "Call +973 17576642";
                  card.call_option.label_ar =
                    "اتصل على " + "17576642" + " 973+ ";
                  card.call_option.phone = "+97317576642";
                } else if (card.value == "Home Assistance") {
                  return false; // Exclude "Home Assistance" if the conditions are not met
                }
                console.log(card.value);
                if (
                  card.value == "Road Assistance" &&
                  policyDetails?.PolicyHeader?.ProductCode == "0101"
                ) {
                  card.call_option.lable_en =
                    "Call +973 " +
                    policyDetails?.PolicyHeader?.AssistCompany?.Contact;
                  card.call_option.label_ar =
                    "اتصل على " +
                    policyDetails?.PolicyHeader?.AssistCompany?.Contact +
                    " 973+ ";
                  card.call_option.phone =
                    "+973" +
                    String(
                      policyDetails?.PolicyHeader?.AssistCompany?.Contact || ""
                    ).replace(/\s+/g, "");
                  if (
                    policyDetails?.PolicyHeader?.AssistCompany?.Contact ===
                    undefined
                  ) {
                    return false;
                  }
                } else {
                  return false;
                }

                if (
                  card.value == "Airport Delivery Services" &&
                  policyDetails?.PolicyHeader?.ProductCode == "0101" &&
                  policyDetails?.PolicyHeader?.Covers?.some(
                    (cover) => cover.coverCode == "CMOT28"
                  )
                ) {
                  card.call_option = card.call_option || {}; // Ensure `call_option` exists
                  card.call_option.lable_en = "Call +973 17218925";
                  card.call_option.label_ar =
                    "اتصل على " + "17218925" + " 973+ ";
                  card.call_option.phone = "+97317218925";
                } else if (card.value == "Airport Delivery Services") {
                  return false; // Exclude "Home Assistance" if the conditions are not met
                }

                // Include all other cards
                return true;
              })
              .map((card, index) => (
                <PerformanceCard
                  key={index}
                  cardData={card}
                  className="flex h-[120px] min-w-[217px] max-w-[240px] flex-col justify-between items-start flex-[1_0_0] border bg-[#F6F8F9] p-4 rounded-2xl border-solid border-[#DDE2E4] ipad:min-w-[120px] ipad:flex ipad:h-[100px] ipad:flex-col ipad:justify-between ipad:items-start ipad:flex-[1_0_0] ipad:px-4 ipad:py-6 ipad:gap-0  max767:border-0 max767:focus:border-solid overviewcard max767:max-w-[48%] max767:h-[120px] max767:flex-col max767:justify-between max767:items-start max767:p-4"
                />
              ))}
          </div>
        )}
        {/* Motor Insurance Documents Section - Only for non-travel insurance */}
        {status == "loading" ? (
          <SkeletonLoader />
        ) : (
          !screenResolution.mobile &&
          downloadCard &&
          policyDetails?.PolicyHeader?.ProductCode != "0204" &&
          policyDetails?.PolicyHeader?.ProductCode != "0213" &&
          policyDetails?.PolicyHeader?.ProductCode != "0710" &&
          policyDetails?.PolicyHeader?.ProductCode != "0202" &&
          policyDetails?.PolicyHeader?.ProductCode != "0222" &&
          !(() => {
            // Also exclude personal cyber policies from motor documents section
            const productName =
              policyDetails?.PolicyHeader?.ProductName?.toLowerCase() || "";
            const planNameLower =
              policyDetails?.PolicyHeader?.PlanName?.toLowerCase() || "";
            return (
              productName.includes("personal cyber") ||
              productName.includes("cyber") ||
              planNameLower.includes("personal cyber") ||
              planNameLower.includes("cyber")
            );
          })() && (
            <div className="justify-center items-start gap-2 self-stretch bg-[#F6F8F9] mt-4 p-6 rounded-[10px]">
              <div className="flex">
                <h3 className="text-[#48535B] text-sm not-italic font-medium leading-[normal] mb-4">
                  {translate(downloadCard?.label_en, downloadCard?.label_ar)}
                </h3>
              </div>
              {downloadCard?.download_btn && (
                <div className=" gap-2 download-wrapper flex flex-wrap w-4/5 ipad:flex ipad:w-[95%]">
                  <DownloadBtn
                    doc={docLabel}
                    filesData={downloadCard.filesData}
                    className={"gap-2 shrink w-[32%]  ipad:w-2/5"}
                  />
                </div>
              )}
            </div>
          )
        )}
      </div>
    </>
  );
};

export default PolicyOverviewTab;
